import { combineReducers } from '@reduxjs/toolkit';
import waitingListReducer from './waiting-list.reducer';

const rootReducer = combineReducers({
  waitingListReducer,
});

export default rootReducer;
